export default __webpack_public_path__ + "static/media/pi.7ecf784b.jpg";